module.exports = __webpack_public_path__ + "static/media/home-banner.57399625.jpg";